module.exports = __webpack_public_path__ + "img/xzBg.9f950c1b.png";